import React, { useEffect, useState } from 'react';
import {
  TextField,
} from '@mui/material';
import { PropTypes } from 'prop-types';
import { checkEmail } from '../../helpers';
import entity from '../entity';

export function FieldEmail({
  field, onChange, indexField, indexGroup, indexFormulario, customize,sx
}) {
  const [myState, setMyState] = useState('');

  useEffect(() => {
    field.value !== '' && field.value !== null && field.value !== undefined && field.value!==entity.INVALID_FORMAT && setMyState(field.value);
  }, [field.value]);

  const hadlerMessagge = () => {
    if (field.required && myState === '') {
      return entity.VALIDATIONS_MESSAGES[1];
    }
    if (field.required && myState !== '' && !checkEmail(myState)) {
      return entity.VALIDATIONS_MESSAGES[2];
    }
    if (!field.required && myState !== '' && !checkEmail(myState)) {
      return entity.VALIDATIONS_MESSAGES[2];
    }
    return entity.VALIDATIONS_MESSAGES[0];
  };

  useEffect(() => {
    if (myState !== '' && checkEmail(myState)) {
      onChange(indexField, myState, indexGroup, indexFormulario);
    } else if (!field.required && myState !== '' && !checkEmail(myState)) {
      onChange(indexField, entity.INVALID_FORMAT, indexGroup, indexFormulario);
    } else {
      onChange(indexField, '', indexGroup, indexFormulario);
    }
  }, [myState]);

  return (
    <TextField
      fullWidth
      size="small"
      label={field.label}
      value={myState}
      InputLabelProps={{ shrink: true }}
      FormHelperTextProps={{
        sx: {
          color: customize.HelperText.color,
          fontSize: customize.HelperText.size,
        },
      }}
      helperText={hadlerMessagge()}
      onChange={(e) => { setMyState(e.target.value); }}
      sx={sx?sx:{mt:2}}
      inputProps={{
        maxLength: field.length && Number(field.length),
        disabled: field.hasOwnProperty('editable') ? field.editable : false,
      
      }}
    />
  );
}

FieldEmail.propTypes = {
  field: PropTypes.objectOf.isRequired,
  onChange: PropTypes.func.isRequired,
  indexField: PropTypes.number.isRequired,
  indexGroup: PropTypes.number.isRequired,
  indexFormulario: PropTypes.number.isRequired,
  customize: PropTypes.objectOf.isRequired,
};

export default FieldEmail;
